( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'pill-photo-l-r', COMPONENT );
} )( app );
